import { render, staticRenderFns } from "./ClipboardList.vue?vue&type=template&id=27b126f8&"
import script from "./ClipboardList.vue?vue&type=script&lang=js&"
export * from "./ClipboardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports